import type { VoidFunctionComponent } from 'react';

import NVDBaseMetrics from '../../../../shared/vulns/Drawer/NVDBaseMetrics';
import type { SelectedVuln } from '../../../../../../shared/organizationPackages/response';

import { getSelectedVulnNVDBaseMetrics } from './utils';

type Props = { isLoading: boolean; selectedVuln?: SelectedVuln };

/**
 * Container component for the VulnerabilityDrawerNVDBaseMetrics
 */
const PackageVersionVulnerabilityDrawerNVDBaseMetrics: VoidFunctionComponent<Props> = ({ isLoading, selectedVuln }) => {
  const metrics = getSelectedVulnNVDBaseMetrics(selectedVuln);
  return (
    <NVDBaseMetrics
      isLoading={isLoading}
      metrics={metrics}
    />
  );
};

export default PackageVersionVulnerabilityDrawerNVDBaseMetrics;
